import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';
const SIGN_UP_MODAL = 'flarum/forum/components/SignUpModal';
const T = k => app.translator.trans(`kapok-plus-email-domain-gate.forum.signup.${k}`);

// Material person_add（邀请用户头衔图标，内联 SVG 自托管）
const INVITED_PATH = 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z';
const invitedTooltip = () => {
  const locale = app.translator && app.translator.locale || 'zh-Hans';
  return locale === 'en' ? 'Invited member' : '邀请用户';
};
app.initializers.add('kapok-plus-email-domain-gate', () => {
  // users.kapok_is_invited → user.kapokIsInvited()
  User.prototype.kapokIsInvited = Model.attribute('kapokIsInvited');

  // 「邀请用户」头衔：凡用邀请码注册的账户都显示
  extend(User.prototype, 'badges', function (items) {
    if (!this.kapokIsInvited || !this.kapokIsInvited()) return;
    items.add('kapok-invited', m("span", {
      className: "Badge Badge--kapok-invited",
      title: invitedTooltip(),
      "aria-label": invitedTooltip()
    }, m("svg", {
      className: "MaterialIcon",
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true"
    }, m("path", {
      d: INVITED_PATH
    }))), 90);
  });
  // 注册弹窗增加「邀请码（选填）」字段
  extend(SIGN_UP_MODAL, 'oninit', function () {
    this.kapokInvite = '';
  });
  extend(SIGN_UP_MODAL, 'fields', function (items) {
    if (this.attrs.token) return;
    items.add('kapokInvite', m("div", {
      className: "Form-group"
    }, m("label", {
      className: "label"
    }, T('invite_label')), m("input", {
      className: "FormControl",
      name: "inviteCode",
      type: "text",
      placeholder: T('invite_placeholder'),
      value: this.kapokInvite,
      oninput: e => {
        this.kapokInvite = e.target.value;
      }
    }), m("p", {
      className: "helpText"
    }, T('invite_hint'))), 15);
  });
  extend(SIGN_UP_MODAL, 'submitData', function (data) {
    if (this.kapokInvite) {
      data.inviteCode = this.kapokInvite.trim();
    }
    return data;
  });
});